import React from 'react';
import { Redirect } from 'react-router';
import { Button, Badge } from 'reactstrap';
import { baseUrl } from '../shared/baseUrl';
import Recorder from '../shared/Recorder';
import { skipCountUpdateServer } from '../functions/dashboard';
import { LoadingText, SendingText } from './Loading';
import audioContext from './AudioContext';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class DashboardText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: localStorage.getItem('language') || 'ENG',
            dropdownOpen: false,
            fetchedText: "",
            recordButtonText: "Record",
            recordButtonColor: "primary",
            isRecording: false,
            displayRecord: "",
            displayPlayback: "none",
            audioBase64: "",
            skipDisplay: "",

            // wavPlayback
            wavUrl: "",
            playbackText: "Play",
            faClass: "ml-1 fa fa-play",
            isPlaying: false,

            // count number of recordings
            recordCount: "Loading...",
        }
        this.playbackAudio = React.createRef();
        this.verifyAudio = React.createRef();
    }

    toggleDropdown = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        })
    }

    dropdownChangeValue = (e) => {
        this.setState({
            language: e.currentTarget.textContent
        })
        localStorage.setItem('language', e.currentTarget.textContent);
        if (JSON.parse(localStorage.getItem('hindiTexts'))) {
            console.log("akjdhakjhdkajshdkaj\,akjhdsakjhdkasjhahksjda");
            this.removeAccess()
                .then(() => {
                    this.getHindiText();
                })
        }
        else {
            this.getHindiText();
        }
    }

    componentDidMount = () => {
        if (this.props.user && this.props.user.isAuthenticated) {
            this.props.getStats()
                .then((stat) => {
                    this.setState({
                        recordCount: localStorage.getItem('recorded')
                    })
                })
            // remove Inaccess flag
            if (JSON.parse(localStorage.getItem('hindiTexts'))) {
                console.log("akjdhkajsdbkjsandjkasdnjadnslnas\njaskjdasnd\n");
                console.log(JSON.parse(localStorage.getItem('hindiTexts')));
                this.removeAccess();
            }
            if (localStorage.getItem('language')) {
                this.setState({
                    language: localStorage.getItem('language')
                })
                this.getHindiText();
            }
            else {
                localStorage.setItem('language', "ENG");
                this.setState({
                    language: localStorage.getItem('language')
                })
                this.getHindiText();
            }

            var constraints = {
                audio: {
                    latency: { ideal: 0.004 },
                    googAutoGainControl: false,
                    googAutoGainControl2: false,
                    googNoiseSuppression: false,
                    googHighpassFilter: false,

                    noiseSuppression: false,
                    autoGainControl: false,
                    // echoCancellation: false,
                    mozNoiseSuppression: false,
                    mozAutoGainControl: false,
                },
                video: false
            }

            // providing legacy support
            if (navigator.mediaDevices === null) {
                navigator.mediaDevices = {};
            }

            if (navigator.mediaDevices.getUserMedia === null) {
                navigator.mediaDevices.getUserMedia = (
                    navigator.getUserMedia ||
                    navigator.webkitGetUserMedia ||
                    navigator.mozGetUserMedia
                )
            }
            navigator.mediaDevices.getUserMedia(constraints)
                .then((stream) => {
                    this.gumStream = stream;
                    this.gumStream.getAudioTracks() // get all tracks from the MediaStream
                        .forEach((track) => {
                            console.log(track);
                            track.stop()
                        }); // stop each of them
                    this.gumStream.getVideoTracks().forEach((track) => {
                        // console.log(track);
                        track.stop();
                    });
                    this.gumStream = null;
                })
        }
    }

    recordFunction = () => {
        // setup the recorder
        // var input;
        // var volume;
        // if(audioContext.state!=="running"){
        //     audioContext.resume()
        //     .then((resp)=>{
        //         console.log("When Recording Start!! "+audioContext.state);
        //     })
        // }
        if (!this.state.isRecording) {

            var input;
            var volume;
            const AudioContext = window.AudioContext || window.webkitAudioContext;
            this.audioContext = new AudioContext();
            console.log("Record On: " + this.audioContext.state);
            // if(this.audioContext.state!=="running"){
            //     this.audioContext.resume()
            //     .then((resp)=>{
            //         console.log("When Recording Start!! "+this.audioContext.state);
            //     })
            // }

            console.log("Inside If\n\n")
            this.setState({
                isRecording: true
            });

            var constraints = {
                audio: {
                    latency: { ideal: 0.004 },
                    googAutoGainControl: false,
                    googAutoGainControl2: false,
                    googNoiseSuppression: false,
                    googHighpassFilter: false,

                    noiseSuppression: false,
                    autoGainControl: false,
                    // echoCancellation: false,
                    mozNoiseSuppression: false,
                    mozAutoGainControl: false
                },
                video: false
            }

            // providing legacy support
            if (navigator.mediaDevices === null) {
                navigator.mediaDevices = {};
            }

            if (navigator.mediaDevices.getUserMedia === null) {
                navigator.mediaDevices.getUserMedia = (
                    navigator.getUserMedia ||
                    navigator.webkitGetUserMedia ||
                    navigator.mozGetUserMedia
                )
            }
            navigator.mediaDevices.getUserMedia(constraints)
                .then((stream) => {
                    this.setState({
                        recordButtonColor: "danger",
                        recordButtonText: "Stop Recording",
                        skipDisplay: "none"
                    })
                    console.log("getUserMedia() success, stream created, initializing Recorder.js ...");
                    /* assign to gumStream for later use */
                    volume = this.audioContext.createGain();
                    console.log(volume);
                    volume.gain.value = 3;
                    this.gumStream = stream;
                    console.log("Recording started");
                    /* use the stream */
                    input = this.audioContext.createMediaStreamSource(stream);
                    input.connect(volume);
                    /* Create the Recorder object and configure to record mono sound (1 channel) Recording 2 channels will double the file size */
                    this.rec = new Recorder(input, {
                        numChannels: 1
                    })
                    //start the recording process
                    this.rec.record();
                }).catch((err) => {
                    console.log("Error in recording: ", err);
                });
        }
        else {
            this.setState({
                isRecording: false,
                recordButtonText: "Record",
                displayPlayback: "",
                displayRecord: "none",
                recordButtonColor: "primary"
            });
            console.log("stopButton clicked");
            //tell the recorder to stop the recording 
            this.rec.stop(); //stop microphone access
            // this.gumStream.getAudioTracks()[0].stop();
            this.gumStream.getAudioTracks() // get all tracks from the MediaStream
                .forEach((track) => {
                    // console.log(track);
                    track.stop()
                }); // stop each of them
            this.gumStream.getVideoTracks().forEach((track) => {
                // console.log(track);
                track.stop();
            });
            this.gumStream = null;
            // input=null;
            //create the wav blob and pass it on to createDownloadLink 
            this.rec.exportWAV(this.createDownloadLink);
            this.rec.exportWAV(this.convertBinaryToBase64);
            this.audioContext.close()
                .then((resp) => {
                    console.log("Closing");
                    console.log("Closing " + this.audioContext.state);
                    this.rec.clear();
                })
        }
    }
    // Convert InAccess to false after page refresh
    removeAccess = () => {

        const storedTexts = JSON.parse(localStorage.getItem('hindiTexts'));
        if (!storedTexts?.array || storedTexts.array.length === 0) {
            console.log("No texts to remove access from");
            return Promise.resolve();
        }

        const putText = storedTexts.array.map(text => text._id);
        // Don't remove localStorage yet
        const bearer = 'Bearer ' + localStorage.getItem('token');

        return fetch(baseUrl + 'hindiText/batchGet/' + localStorage.getItem('language'), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': bearer
            },
            body: JSON.stringify({
                hindiTextId: putText
            })
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(errData => {
                    throw new Error('Error ' + response.status + ': ' + (errData.message || response.statusText));
                });
            }
            return response.json();
        })
        .then(response => {
            if (response.success) {
                // Only remove localStorage after successful API call
                localStorage.removeItem('hindiTexts');
                console.log("Successfully removed access:", response);
                return response;
            }
            throw new Error('Error: ' + (response.message || 'Operation failed'));
        })
        .catch(err => {
            console.error("Error in removeAccess:", err);
            throw err;
        });
    }

    // function to retrieve hindiText fomr the server
    // getHindiText = () =>{
    //     const bearer = 'Bearer ' + localStorage.getItem('token');
    //     return fetch(baseUrl+'hindiText/batchGet/'+localStorage.getItem('language'),{
    //         method: 'GET',
    //         headers: {
    //             "Content-Type": "application/json",
    //             'Authorization': bearer
    //           },
    //         credentials: 'same-origin'
    //     })
    //     .then(response =>{
    //         if(response.ok){
    //             // console.log("returned  response is a success");
    //             // console.log(response);
    //             return response;
    //         }
    //         else{
    //             var error = new Error("Response failed!!");
    //             error.response = response;
    //             console.log(response);
    //             throw error;
    //         }
    //     },(err)=>{
    //         var errmess = new Error(err.message+"hulalalala")
    //         throw errmess;
    //     })
    //     .then(response=>{
    //         // console.log("Inside Reponse\n",response)//
    //         return response.json()
    //     })
    //     .then((hindiTexts)=>{
    //         var current = localStorage.getItem('hindiTexts');
    //         // console.log("This is current "+current);
    //         if(current===null){
    //             localStorage.setItem('hindiTexts',JSON.stringify({
    //                 array:hindiTexts
    //             }));
    //             this.setState({
    //                 fetchedText:JSON.parse(localStorage.getItem('hindiTexts')).array[0]
    //             });
    //         }
    //         else{
    //             var localArray = JSON.parse(localStorage.getItem('hindiTexts')).array;
    //             localArray=localArray.concat(hindiTexts);
    //             console.log(localArray);
    //             localStorage.setItem('hindiTexts',JSON.stringify({
    //                 array:localArray
    //             }));
    //             this.setState({
    //                 fetchedText:localArray[0]
    //             });
    //         }
    //         // console.log("Inside GetItem: ",localStorage.getItem('hindiTexts'));
    //     })
    //     .catch((err)=>console.log(err));
    // }

    getHindiText = async () => {

        try {
            const response = await fetch(`${baseUrl}hindiText/batchGet/${this.state.language}`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
                credentials: 'same-origin'
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }
            const hindiTexts = (await response.json()).data;
            const currentTexts = JSON.parse(localStorage.getItem('hindiTexts'))?.array || [];
            const updatedTexts = [...currentTexts, ...hindiTexts];

            // Update local storage with new texts
            localStorage.setItem('hindiTexts', JSON.stringify({ array: updatedTexts }));

            // Update state with the first available text
            this.setState({
                fetchedText: updatedTexts[0] || "",
            });
        } catch (err) {
            console.error("Failed to fetch Hindi texts:", err);
            // Optional: Update UI or state with an error message
            this.setState({ fetchedText: "Error fetching texts. Please try again." });
        }
    };


    convertBinaryToBase64 = (blob) => {
        // convert To base64
        // console.log(blob);
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        var audioBase64;
        reader.onloadend = () => {
            audioBase64 = reader.result;
            // console.log(audioBase64);
            audioBase64 = audioBase64.split(',')[1];
            // console.log(audioBase64);
            this.setState({ audioBase64: audioBase64 });
        }
    }

    createDownloadLink = (blob) => {
        var playbackAudio = this.playbackAudio.current;
        var URL = window.URL || window.webkitURL;
        var url = URL.createObjectURL(blob);

        this.setState({
            wavUrl: url
        })
        // playbackAudio.setAttribute('controls', true);
        // playbackAudio.setAttribute('src', url);
        // if i want to download
        // const dl = document.createElement('a');
        // dl.href = url;
        // dl.download = 'I_this_happening.wav';
        // dl.click()
    }

    recordAgain = () => {
        this.setState({
            isRecording: false,
            recordButtonText: "Record",
            displayPlayback: "none",
            displayRecord: "",
            skipDisplay: "",
            audioBase64: "",
            wavUrl: "",
            playbackText: "Play",
            isPlaying: false,
            faClass: "fa fa-play ml-1"
        });
    }

    submitFunction = () => {
        this.setState({
            playbackText: "Play",
            isPlaying: false,
            faClass: "fa fa-play ml-1",
            wavUrl: "",
        });
        // upload Audio and update record count on success
        this.props.uploadAudio(
            this.state.fetchedText.fileNumber,
            this.state.fetchedText._id,
            this.state.audioBase64,
            this.state.fetchedText.language
        )
            .then((resp) => {
                // this.props.updateStatsServer(true)
                // .then((resp)=>{
                if (resp.success) {
                    var recordedCount = localStorage.getItem('recorded')
                        ? parseInt(localStorage.getItem('recorded'), 10) + 1
                        : 1;
                    // console.log("Updated recorded Count:\n"+typeof(recordCount));

                    localStorage.setItem('recorded', recordedCount);
                    this.setState({
                        recordCount: recordedCount
                    });
                }
                else {
                    console.log("Cannot Update server");
                }
                // })
                // .catch((err)=>console.log(err));
            })
            .catch(err => console.log(err));

        // Update Text
        var nextItem = JSON.parse(localStorage.getItem('hindiTexts')).array;
        nextItem.splice(0, 1);
        localStorage.setItem('hindiTexts', JSON.stringify({
            array: nextItem
        }));

        this.setState({
            fetchedText: nextItem.length === 0 ? "" : nextItem[0],
            isRecording: false,
            recordButtonText: "Record",
            displayPlayback: "none",
            displayRecord: "",
            audioBase64: "",
            skipDisplay: ""
        })
        if (nextItem.length === 1) {
            this.getHindiText();
        }
        console.log("Inside GetItem: ", JSON.parse(localStorage.getItem('hindiTexts')));
    }


    skipText = () => {
        var oldHindiTextId = this.state.fetchedText._id;
        var nextItem = JSON.parse(localStorage.getItem('hindiTexts')).array;
        nextItem.splice(0, 1);
        localStorage.setItem('hindiTexts', JSON.stringify({
            array: nextItem
        }));
        console.log("Inside GetItem: ", JSON.parse(localStorage.getItem('hindiTexts')));
        this.setState({
            fetchedText: nextItem.length === 0 ? "" : nextItem[0],
            isRecording: false,
            recordButtonText: "Record",
            displayPlayback: "none",
            displayRecord: "",
            audioBase64: "",
            wavUrl: "",
            playbackText: "Play",
            isPlaying: false,
            faClass: "fa fa-play ml-1",
            recordButtonColor: "primary"
        })
        if (nextItem.length === 1) {
            this.getHindiText();
        }
        if (oldHindiTextId) {
            // increase skip count
            skipCountUpdateServer(oldHindiTextId)
                .then((resp) => console.log(resp))
        }
    }

    // custom playback control
    playbackButtonSubmit = () => {
        var playbackAudio = this.playbackAudio.current;
        playbackAudio.volumne = 1;
        if (!this.state.isPlaying) {
            this.setState({
                playbackText: "Pause",
                isPlaying: !this.state.isPlaying,
                faClass: "fa fa-pause ml-1"
            });
            playbackAudio.play();
        }
        else {
            this.setState({
                playbackText: "Play",
                isPlaying: !this.state.isPlaying,
                faClass: "fa fa-play ml-1"
            });
            playbackAudio.pause();
        }
    }

    playbackOnEnd = () => {
        this.setState({
            playbackText: "Play",
            isPlaying: false,
            faClass: "fa fa-play ml-1"
        });
    }

    render() {
        // console.log(this.props.user);
        if (!this.props.user?.isAuthenticated) {
            return (
                <Redirect to='/' />
            );
        }
        return (
            <div>
                <div>
                    <Dropdown
                        isOpen={this.state.dropdownOpen}
                        toggle={this.toggleDropdown}
                        onClick={this.onClickDropdown}
                    >
                        <DropdownToggle caret color="success">
                            {this.state.language}
                        </DropdownToggle>
                        <DropdownMenu style={{ width: "max-content" }}>
                            <DropdownItem onClick={this.dropdownChangeValue}><strong>ENG</strong></DropdownItem>
                            <DropdownItem onClick={this.dropdownChangeValue}><strong>HIN</strong></DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                {
                    this.state.fetchedText === "" ?
                        <div
                            className="mt-2 pb-2 pl-2 pr-2">
                            <LoadingText />
                        </div>
                        :
                        <div
                            className="recordDiv mt-2 pb-2 pl-2 pr-2"
                        // style={{
                        //     display:this.state.divRecord
                        // }}
                        >
                            <div className="row">
                                <div className="ml-auto mr-3">
                                    <h5>
                                        <Badge color="warning">
                                            Recorded {this.state.recordCount}
                                        </Badge>
                                    </h5>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <h6><Badge>Read</Badge></h6>
                                    <h5>{this.state.fetchedText.hindiText}</h5>
                                </div>
                            </div>

                            <div className="row ml-auto justify-content-end mr-2" style={
                                { display: this.state.displayRecord }
                            }>
                                <div style={{ display: this.state.skipDisplay }}>
                                    <Button
                                        className="mr-2"
                                        style={{ backgroundColor: "#343a40" }}
                                        onClick={this.skipText}>
                                        Skip</Button>
                                </div>
                                <div>
                                    <Button
                                        color={this.state.recordButtonColor}
                                        onClick={() => this.recordFunction()}>
                                        {this.state.recordButtonText}</Button>
                                </div>
                            </div>

                            <div className="row"
                                style={{
                                    display: this.state.displayPlayback
                                }}>
                                <div className="ml-3">
                                    {this.state.wavUrl && this.state.wavUrl !== "" && (
                                        <>
                                            <audio
                                                ref={this.playbackAudio}
                                                controlsList="nodownload"
                                                src={this.state.wavUrl}
                                                onEnded={this.playbackOnEnd}
                                            >
                                            </audio>
                                        </>
                                    )
                                    }
                                    {/* <div>
                                <Button
                                onClick={this.playbackButtonSubmit}
                                style={{
                                    backgroundColor:"#343a40"
                                }}
                                >{this.state.playbackText}
                                    <i className={this.state.faClass}></i>
                                </Button>
                            </div> */}
                                </div>
                                <div className="row ml-auto mr-3" style={{
                                    display: this.state.displayPlayback,
                                    // marginLeft:"auto"
                                }}>
                                    <div>
                                        <Button color="danger"
                                            onClick={() => this.recordAgain()}
                                        >Delete</Button>
                                    </div>
                                    <div className="ml-2">
                                        <Button color="success"
                                            onClick={() => this.submitFunction()}
                                        >Submit</Button>
                                    </div>
                                    <div className="ml-2">
                                        <Button
                                            onClick={this.playbackButtonSubmit}
                                            style={{
                                                backgroundColor: "#343a40"
                                            }}
                                        >{this.state.playbackText}
                                            <i className={this.state.faClass}></i>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default DashboardText;